import React from 'react';

const BookJournals=()=>{
    return(
        <div>list</div>
    )
}

export default BookJournals;